module.exports = __webpack_public_path__ + "img/020001.261edda3.png";